import React from 'react'

export default function BrowseAllModelsCard({ isSaleOff, keywords }) {
  const text = isSaleOff ? (
    `The perfect ${keywords} model might not be on sale at the moment`
  ) : (
    "Couldn't find 3D Models with loyalty discounts?"
  )

  return (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xxl-2">
      <div className="content-box is-no-results-box content-box--interactive">
        <div className="content-box__content no-results">
          <div className="l-inner-compact">
            <div className="content-text u-text-center">{text}</div>
            <div className="content-action u-text-center">
              <a href="/3d-models?page=1" className="btn btn-primary btn-sm btn-fat">
                Browse all {keywords} models
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
